import difference from 'lodash/difference';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import { PostSource } from '../../../data-layer/posts/constants';
import * as postsService from '../../../data-layer/posts/service';
import { PostModel } from '../../../data-layer/posts/types';
import { UserModel } from '../../../data-layer/user/types';
import { StatusFilter } from '../../../ui/posts/FeedManagement/types';
import { PostStatus } from '../../../ui/posts/constants';
import { PostCollectionFilters } from '../../post/usePostCollection';
import {
    QUERY_PARAMETER_DATE_FROM,
    QUERY_PARAMETER_DATE_TO,
    QUERY_PARAMETER_PERIOD,
    QUERY_PARAMETER_SOURCE,
    QUERY_PARAMETER_STATUS,
    STATUS_FILTER_MAPPING,
} from './constants';
import { IdentifierDictionary } from './types';

export const makeIdentifiers = (mapping: IdentifierDictionary) => keys(pickBy(mapping, Boolean));

export const makeFilters = (query: URLSearchParams): Partial<PostCollectionFilters> => {
    const source = query.get(QUERY_PARAMETER_SOURCE);
    const status = query.get(QUERY_PARAMETER_STATUS);
    const period = query.get(QUERY_PARAMETER_PERIOD);
    const dateFrom = query.get(QUERY_PARAMETER_DATE_FROM);
    const dateTo = query.get(QUERY_PARAMETER_DATE_TO);

    return {
        data_sources: source ? [source as PostSource] : [],
        statuses: STATUS_FILTER_MAPPING[status || StatusFilter.ALL],
        period: period ? period : undefined,
        date_from: dateFrom ? dateFrom : undefined,
        date_to: dateTo ? dateTo : undefined,
    } as any;
};

export const isAllSelected = (models: PostModel[], identifiers: string[]) =>
    identifiers.length > 0 &&
    difference(
        models.map((model) => model.id),
        identifiers,
    ).length === 0;

export const makeMapping = (models: PostModel[]): IdentifierDictionary =>
    models.reduce(
        (mapping, model) => ({
            ...mapping,
            [model.id]: true,
        }),
        {},
    );

export const canChangeStatusBulk = (
    models: PostModel[],
    identifiers: string[],
    status: PostStatus,
    user: UserModel,
) =>
    identifiers.length > 0 &&
    models
        .filter((model) => identifiers.includes(model.id))
        .every((model) => postsService.canChangeStatus(model, status, user));

export const makeSearchParams = (
    searchParams: URLSearchParams,
    params: { name: string; value: string | null | undefined }[],
): URLSearchParams => {
    params.forEach((param) => {
        if (param.value && param.value !== 'undefined') {
            searchParams.set(param.name, param.value);
        } else {
            searchParams.delete(param.name);
        }
    });

    return searchParams;
};
